import { saveAs } from "file-saver";

export class Util {
    static anos() {
        return [
            { label: "2033", value: 2033 },
            { label: "2032", value: 2032 },
            { label: "2031", value: 2031 },
            { label: "2030", value: 2030 },
            { label: "2029", value: 2029 },
            { label: "2028", value: 2028 },
            { label: "2027", value: 2027 },
            { label: "2026", value: 2026 },
            { label: "2025", value: 2025 },
            { label: "2024", value: 2024 },
            { label: "2023", value: 2023 },
            { label: "2022", value: 2022 },
            { label: "2021", value: 2021 },
            { label: "2020", value: 2020 },
            { label: "2019", value: 2019 },
            { label: "2018", value: 2018 },
            { label: "2017", value: 2017 },
            { label: "2016", value: 2016 },
            { label: "2015", value: 2015 },
        ];
    }

    static randomId() {
        let text = "";
        const possible =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (let i = 0; i < 5; i++)
            text += possible.charAt(
                Math.floor(Math.random() * possible.length),
            );

        return text;
    }

    static defaultInputClass(size: string) {
        return {[`w-${size} md:w-${size} sm:w-12`]: true}
    }

    static expandedQuery(campos: any, replace?: boolean) {
        let query = "?$expand=" + campos[0];
        for (let i = 1; i < campos.length; i++) {
            query = query + "&$expand=" + campos[i];
        }
        return replace ? query.replace("?", "&") : query;
    }

    static expandedQueryObjeto(campos: string, replace?: boolean) {
        let query = "?$expand=" + campos;
        for (let i = 1; i < campos.length; i++) {
            query = query + "&$expand=" + campos;
        }
        return replace ? query.replace("?", "&") : query;
    }

    static cadastroRoute() {
        return "cadastro";
    }

    static pushErrorMsg(error: any): any {
        try {
            return [{ severity: "error", summary: error, life: 60000 }];
        } catch (e) {
            return [
                {
                    severity: "error",
                    summary: JSON.stringify(error),
                    life: 60000,
                },
            ];
        }
    }

    static pushSuccessMsg(msg: any): any {
        try {
            //sticky: true
            return [{ severity: "success", summary: msg, life: 60000 }];
        } catch (e) {
            return [
                {
                    severity: "success",
                    summary: JSON.stringify(msg),
                    life: 60000,
                },
            ]; //sticky: true
        }
    }

    static pushSuccessMsgSemDelay(msg = "Operação concluída!"): any {
        try {
            return [{ severity: "success", summary: msg, life: 60000 }];
        } catch (e) {
            return [
                {
                    severity: "success",
                    summary: JSON.stringify(msg),
                    life: 60000,
                },
            ];
        }
    }

    static pushInfoMessage(msg: any): any {
        try {
            return [{ severity: "info", summary: msg, life: 60000 }];
        } catch (e) {
            return [
                { severity: "info", summary: JSON.stringify(msg), life: 60000 },
            ];
        }
    }

    static valueToSelect(value: any) {
        const label = value["Nome"] ? value["Nome"] : value["Descricao"];
        return { label, value: value["Id"] };
    }

    static toNumber = (val: any, casas = 2) => {
        const v =
            val === undefined
                ? 0
                : val === null
                  ? 0
                  : typeof val === "number"
                    ? Number(val.toFixed(casas))
                    : Number(
                          Number.parseFloat(
                              val.toString().replace(",", "."),
                          ).toFixed(casas),
                      );
        return isNaN(v) || !isFinite(v) ? 0 : v;
    };

    static toNumber2 = (val: any) => {
        const v =
            val === undefined
                ? 0
                : val === null
                  ? 0
                  : typeof val === "number"
                    ? val
                    : Number.parseFloat(val.replace(",", "."));
        return isNaN(v) ? 0 : v;
    };

    static formataVirgula = (value: any) => {
        if (value === undefined || value === null || value === "") {
            return "0,00";
        } else {
            let data = "" + value;
            data = data.replace(/\./g, ",");
            data = data.match(/,\d{1}$/g)
                ? data + "0"
                : data.match(/,\d{2}/g)
                  ? data
                  : data + ",00";
            return data;
        }
    };

    static up(value: any) {
        //value === undefined || value === null ? '' : typeof value === 'string' ? value.toUpperCase() : value
        return value;
    }

    static lower = (value: any) =>
        value === undefined || value === null
            ? ""
            : typeof value === "string"
              ? value.toLowerCase()
              : value;

    static uuidv4() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (c) {
                // tslint:disable-next-line:no-bitwise triple-equals
                const r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            },
        );
    }

    static getDateComUmMesAntes() {
        const currentDate = new Date();
        return new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    }

    static getDateComUmMesAntesComHoras() {
        const currentDate = new Date();
        return new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            currentDate.getHours(),
            currentDate.getMinutes(),
        );
    }

    static getDateComMesAnterior() {
        const currentDate = new Date();
        return new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() - 1,
            1,
        );
    }

    static getDateComTresMesAntes() {
        const currentDate = new Date();
        return new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDay() - 60,
        );
    }

    static getDateComSeteDiasAntes() {
        const currentDate = new Date();
        return new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDay() - 6,
        );
    }

    static getDatePreviousMonth(d: Date) {
        d.setMonth(d.getMonth() - 1);
        return d;
    }

    static getLastDayDateMesAnterior() {
        const currentDate = new Date();
        return new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
    }

    static getLastDayDateMesDepois() {
        const currentDate = new Date();
        return new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDay() + 56,
        );
    }

    static getLastDayDate() {
        const currentDate = new Date();
        return new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() + 1,
            0,
        );
    }

    static getLastDayDateComHoras() {
        const currentDate = new Date();
        return new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() + 2,
            currentDate.getHours(),
            currentDate.getMinutes(),
        );
    }

    static getYesterdayDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 1);
        return currentDate;
    }

    static getSixtyDaysAhead() {
        const currentDate = new Date();
        // Mantém o ano, o mês e soma 60 ao dia atual
        return new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() + 60,
        );
    }

    static isNegative = (v: any) => Util.toNumber(v) < 0;

    static extractErrorMessage = (v: any) => {
        if (typeof v !== "object") return v;
        try {
            return v.message;
        } catch (e) {
            return v;
        }
    };

    static getMonthLabel(v: any) {
        switch (v) {
            case 0:
                return "Jan";
            case 1:
                return "Fev";
            case 2:
                return "Mar";
            case 3:
                return "Abr";
            case 4:
                return "Mai";
            case 5:
                return "Jun";
            case 6:
                return "Jul";
            case 7:
                return "Ago";
            case 8:
                return "Set";
            case 9:
                return "Out";
            case 10:
                return "Nov";
            case 11:
                return "Dez";
            default:
                return "";
        }
    }

    static addZero = (v: any) => (v.toString().length === 1 ? "0" + v : v);

    static extractFileErrorMessage(e: any) {
        let decodedString = new TextDecoder("utf-8").decode(
            new Uint8Array(e.error),
        );
        const message = JSON.parse(decodedString)["error"]["message"];
        let arr = message.toString().split("");
        arr = arr.map((x: any) => (x === "." ? x + "       \n\n" : x));
        const result = arr.join("");
        return result;
    }

    static dataParaString(date: Date) {
        return `${date.getFullYear()}-${Util.addZero(date.getMonth() + 1)}-${date.getDate()}`;
    }

    static dataParaStringComZero(date: Date) {        
        if (typeof date === "string") return;
        if (date === null || date === undefined) return;
        return `${date.getFullYear()}-${Util.addZero(date.getMonth() + 1)}-${Util.addZero(date.getDate())}`;
    }

    static dataParaStringComZeroEHora(date: Date) {
        return `${date.getFullYear()}-${Util.addZero(date.getMonth() + 1)}-${Util.addZero(date.getDate())}T${Util.addZero(date.getHours())}:${Util.addZero(date.getMinutes())}`;
    }

    static dataParaStringComZeroEHora23(date: Date) {
        return `${date.getFullYear()}-${Util.addZero(date.getMonth() + 1)}-${Util.addZero(date.getDate())}T23:59`;
    }

    static formatarData(value: any) {
        // transform(value: any, args?: any): any {
        if (value === undefined || value === null) return "";

        if (value.toString().includes("T")) {
            value = value.replace(/T.+/, "");
        }

        if (value.toString().length === 10)
            return value.toString().split("-").reverse().join("/");
        if (value.toString().length === 23)
            return value
                .toString()
                .substring(0, 10)
                .split("-")
                .reverse()
                .join("/");
        if (value.toString().length === 19) {
            return value
                .toString()
                .substring(0, 10)
                .split("-")
                .reverse()
                .join("/");
        } else {
            return value;
        }
        // }
    }

    static saveCsvFromRelatorio(v: any) {
        // @ts-ignore
        let decoded = String.fromCharCode(...new Uint8Array(v.body));
        const fileName = v.headers.get("file-name");
        const file = new Blob([decoded], { type: "text/csv;charset=UTF-8" });
        saveAs(file, fileName);
    }

    static saveZip(v: any) {
        const blob = new Blob([v.body], { type: "application/zip" });

        // @ts-ignore
        const fileName = v.headers.get("file-name");
        saveAs(blob, fileName);
    }

    static savePdf(v: any) {
        const fileName = v.headers.get("file-name");
        const file = new Blob([v.body], { type: "application/pdf" });
        const fileURL = window.URL.createObjectURL(file);
        window.open(fileURL, "_blank");
        saveAs(file, fileName);
    }

    static saveImage(v: any) {
        const fileName = v.headers.get("file-name");
        const file = new Blob([v.body], { type: "application/png" });
        const fileURL = window.URL.createObjectURL(file);
        window.open(fileURL, "_blank");
        saveAs(file, fileName);
    }

    static saveXml(v: any) {
        const fileName = v.headers.get("file-name");
        const file = new Blob([v.body], { type: "text/xml" });
        saveAs(file, fileName);
    }

    static saveTxt = (conteudo: any, nomeArquivo: string = "dados.txt") => {
        const blob = new Blob([conteudo], { type: "text/plain;charset=utf-8" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = nomeArquivo;
        link.click();
    };

    static saveExcelFile(v: any) {
        // @ts-ignore
        let fileName = v.headers.get("file-name");
        if (fileName !== null)
            fileName = fileName.replace(
                "https://xmldfe.s3-sa-east-1.amazonaws.com/",
                "",
            );
        const file = new Blob([v.body], {
            type: v.headers.get("Content-Type"),
        });
        saveAs(file, fileName);
    }

    static saveTextFile(v: any) {
        // @ts-ignore
        let decoded = String.fromCharCode(...new Uint8Array(v.body));
        let fileName = v.headers.get("file-name");
        if (fileName !== null)
            fileName = fileName.replace(
                "https://xmldfe.s3-sa-east-1.amazonaws.com/",
                "",
            );
        const file = new Blob([decoded], {
            type: v.headers.get("Content-Type"),
        });
        saveAs(v, fileName);
    }

    static saveTextFileAnsi(v: any) {
        // @ts-ignore
        let decoded = String.fromCharCode(...new Uint8Array(v.body));
        let fileName = v.headers.get("file-name");
        if (fileName !== null)
            fileName = fileName.replace(
                "https://xmldfe.s3-sa-east-1.amazonaws.com/",
                "",
            );
        const file = new Blob([decoded], {
            type: "text/csv;charset=windows-1252",
        });
        saveAs(file, fileName);
    }

    static removerLink(link: string = "") {
        if ((link = "https://hunnotemp.s3.amazonaws.com/")) {
            return link.slice(35);
            // link.replace('https://hunnotemp.s3.amazonaws.com/', '')
        } else if ((link = "https://toqwebtemp.s3.amazonaws.com/")) {
            return link.slice(-35);
            // link.replace('https://toqwebtemp.s3.amazonaws.com/', '')
        }
    }

    // saveAs(v, this.link.replace("https://toqwebtemp.s3.amazonaws.com/", ''));
}

export const sum = (a: number, b: number) => {
    a = Util.toNumber(a);
    b = Util.toNumber(b);
    return Util.toNumber((a + b).toFixed(2));
};

export const sub = (a: number, b: number) => {
    a = Util.toNumber(a);
    b = Util.toNumber(b);
    return Util.toNumber((a - b).toFixed(2));
};

export const sub3Numeros = (a: number, b: number, c: number) => {
    a = Util.toNumber(a, 6);
    b = Util.toNumber(b, 6);
    c = Util.toNumber(c, 6);
    return Util.toNumber((a - b - c).toFixed(6), 6);
};

export const calcularPorcentagem = (
    valorInicial: number,
    valorFinal: number,
) => {
    valorInicial = Util.toNumber(valorInicial);
    valorFinal = Util.toNumber(valorFinal);
    return Util.toNumber(((valorFinal * 100) / valorInicial).toFixed(2));
};

export const mul = (a: number, b: number) => {
    a = Util.toNumber(a);
    b = Util.toNumber(b);
    return Util.toNumber((a * b).toFixed(2));
};

export const div = (a: number, b: number) => {
    a = Util.toNumber(a);
    b = Util.toNumber(b);
    return Util.toNumber((a / b).toFixed(2));
};

export const sum6 = (a: number, b: number) => {
    a = Util.toNumber(a, 6);
    b = Util.toNumber(b, 6);
    return Util.toNumber((a + b).toFixed(6), 6);
};

export const sum8Numeros = (
    a: number,
    b: number,
    c?: number,
    d?: number,
    e?: number,
    f?: number,
    g?: number,
    h?: number,
) => {
    a = Util.toNumber(a, 6);
    b = Util.toNumber(b, 6);
    c = c ? Util.toNumber(c, 6) : 0;
    d = d ? Util.toNumber(d, 6) : 0;
    e = e ? Util.toNumber(e, 6) : 0;
    f = f ? Util.toNumber(f, 6) : 0;
    g = g ? Util.toNumber(g, 6) : 0;
    h = h ? Util.toNumber(h, 6) : 0;
    return Util.toNumber((a + b + c + d + e + f + g + h).toFixed(6), 6);
};

export const sub6 = (a: number, b: number) => {
    a = Util.toNumber(a, 6);
    b = Util.toNumber(b, 6);
    return Util.toNumber((a - b).toFixed(6), 6);
};

export const mul6 = (a: any, b: any) => {
    a = Util.toNumber(a, 6);
    b = Util.toNumber(b, 6);
    return Util.toNumber((a * b).toFixed(6), 6);
};

export const div6 = (a: number, b: number) => {
    a = Util.toNumber(a, 6);
    b = Util.toNumber(b, 6);
    return Util.toNumber((a / b).toFixed(6), 6);
};

export const hasValue = (v: any) =>
    v !== undefined &&
    v !== null &&
    v !== "" &&
    v !== 0 &&
    v !== "0" &&
    v !== "0,00" &&
    v !== "0.00";